import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCidade } from '../../app/slices/cidadesSlice';
import { fecharModalAjuda } from '../../app/slices/modalSlice';
import { ContainerJanela, Divisor, Linha } from '../../styles/base';
import { replaceTags } from '../../util/stringFactory';
import Botao from '../Botao/Botao';
import { Ajuda, JanelaAjuda, TituloAjuda } from './ModalInformacaoAcompanhamentoEstilo';

const ModalInformacaoAcompanhamento = ({ sic, zeladoria }) => {
  const dispatch = useDispatch();
  const dadosCidade = useSelector(selectCidade);

  if (sic) {
    return (
      <ContainerJanela>
        <JanelaAjuda>
          <Linha style={{ justifyContent: 'flex-end' }}>
            <Botao
              fechar
              onClick={() => dispatch(fecharModalAjuda())}
            />
          </Linha>

          <TituloAjuda>Pedido de Informação (e-SIC) - Acompanhamentos</TituloAjuda>

          <Divisor />

          <Ajuda>
            Consulta disponível apenas para pedidos de informações que foram solicitados de forma anônima.
            Para pedidos de informações identificados é necessário realizar o login no aplicativo/site.
          </Ajuda>

        </JanelaAjuda>
      </ContainerJanela>
    );
  }

  if (zeladoria) {
    return (
      <ContainerJanela>
        <JanelaAjuda>
          <Linha style={{ justifyContent: 'flex-end' }}>
            <Botao
              fechar
              onClick={() => dispatch(fecharModalAjuda())}
            />
          </Linha>

          <TituloAjuda>Zeladoria - Acompanhamentos</TituloAjuda>

          <Divisor />

          <Ajuda>
            Consulta disponível apenas para zeladorias que foram solicitadas de forma anônima.
            Para zeladorias identificadas é necessário realizar o login no aplicativo/site.
          </Ajuda>

        </JanelaAjuda>
      </ContainerJanela>
    );
  }

  return (
    <ContainerJanela>
      <JanelaAjuda>
        <Linha style={{ justifyContent: 'flex-end' }}>
          <Botao
            fechar
            onClick={() => dispatch(fecharModalAjuda())}
          />
        </Linha>

        <TituloAjuda>Ouvidoria - Acompanhamentos</TituloAjuda>

        <Divisor />

        <Ajuda>
          Consulta disponível apenas para manifestações que foram solicitados de forma anônima.
          Para manifestações identificadas é necessário realizar o login no aplicativo/site.
        </Ajuda>

      </JanelaAjuda>
    </ContainerJanela>
  );
};

ModalInformacaoAcompanhamento.propTypes = {
  sic: PropTypes.bool.isRequired,
  zeladoria: PropTypes.bool.isRequired,
};

export default ModalInformacaoAcompanhamento;
